import React, { useCallback } from 'react'
import { SocialProviderLinksRow, Providers } from '@fs/identity.js'

const linkNames = {
  // values match legacy app
  [Providers.FACEBOOK]: 'Facebook',
  [Providers.GOOGLE]: 'Google',
  [Providers.APPLE]: 'Apple',
  [Providers.CHURCH_ACCOUNT]: 'ChurchAccountOkta',
}

export default function SocialProviderLinksRowApp() {
  const renderProviderProps = useCallback((provider) => {
    const href = `/oauth2/authorization/${provider}`
    return {
      href,
      linkName: `Sign In with: ${linkNames[provider]}`,
      noPrependLocaleCode: true,
    }
  }, [])
  return <SocialProviderLinksRow renderProviderProps={renderProviderProps} />
}
